import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=f9bc9ffe&scoped=true&"
import script from "./Popup.vue?vue&type=script&lang=js&"
export * from "./Popup.vue?vue&type=script&lang=js&"
import style0 from "./Popup.vue?vue&type=style&index=0&id=f9bc9ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bc9ffe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralModal: require('/home/nvpa/nvpa-corporate/nuxt/components/general/Modal.vue').default})
